import '../tokens/border-radiuses.js';
import '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import { shadows } from '../tokens/shadows.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Collection of alias tokens for text shadows. Adds semantic meaning to base shadow tokens.
 */ const textShadowAliases = {
    none: shadows.none,
    normal: shadows.weaker
};

export { textShadowAliases };
//# sourceMappingURL=text-shadows.js.map
